import { useMemo } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Image, Text } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { AuthLoginStep } from 'auth/models'
import clsx from 'clsx'
import { ClientLogo } from 'common/components'
import { useLoadClientAssets, useSelector } from 'common/hooks'
import { loadStaticFromPublic } from 'common/utils'
import { ROUTES } from 'services'

import LoginStepper from './LoginStepper'

import classes from './components.module.css'

export default function AuthWrapper() {
  const { isLoginPageUiCenter, loginStep } = useSelector((state) => state.auth)
  const { logoColor } = useLoadClientAssets()
  const matches = useMediaQuery('(min-width: 768px)')
  const { user } = useSelector((state) => state.auth)

  const isAccessToken = localStorage.getItem('access_token')
  const isClientId = localStorage.getItem('client_id')
  const isApplicationid = localStorage.getItem('application_id')
  const isSiteId = localStorage.getItem('site_id')

  const isSelectStep = useMemo(
    () =>
      loginStep === AuthLoginStep.SELECT_CLIENT ||
      loginStep === AuthLoginStep.SELECT_APPLICATION ||
      loginStep === AuthLoginStep.SELECT_SITE,
    [loginStep],
  )

  const isForgotOrResetPasswordStep = useMemo(
    () =>
      loginStep === AuthLoginStep.FORGOT_PASSWORD ||
      loginStep === AuthLoginStep.RESET_PASSWORD,
    [loginStep],
  )

  if (user && isAccessToken && isClientId && isApplicationid && isSiteId) {
    return <Navigate to={ROUTES.home()} />
  }

  if (isSelectStep) {
    return (
      <main className={'w-full min-h-screen flex justify-center'}>
        <div
          className={clsx(
            'hidden fixed top-0 left-0 z-10 w-[40vw] h-full md:block',
            classes.loginFormBackground,
          )}
        />
        <div className={'flex flex-col h-auto w-full md:flex-row md:w-auto md:my-auto'}>
          <section
            className={clsx(
              'flex items-center justify-end w-full z-20 py-[40px] md:py-4 md:w-[40vw]',
              matches ? '' : `${classes.loginFormBackground} px-8`,
            )}
          >
            <div
              className={
                'flex flex-col text-center w-full md:text-left md:px-8 md:items-center'
              }
            >
              <div className={'w-full flex flex-col items-center'}>
                <LoginStepper />
              </div>
            </div>
          </section>
          <section
            className={clsx(
              'flex justify-start w-full z-20 px-8 py-8 md:w-[60vw] md:py-4 md:h-auto min-h-[calc(100vh-80px)]',
            )}
          >
            <Outlet />
          </section>
        </div>
      </main>
    )
  }

  return (
    <main className={'w-full min-h-screen flex justify-center'}>
      <div
        className={clsx(
          'hidden fixed top-0 left-0 z-10 w-[40vw] h-full md:block',
          classes.loginFormBackground,
        )}
      />
      <div className={'flex flex-col h-auto w-full md:flex-row md:w-auto md:my-auto'}>
        <section
          className={clsx(
            'flex items-center justify-end w-full z-20 py-[40px] md:py-4 md:w-[40vw] relative',
            matches ? '' : `${classes.loginFormBackground} px-8`,
          )}
        >
          <div
            className={
              'flex flex-col text-center w-full md:text-left md:px-8 md:items-center'
            }
          >
            <Image
              className={'hidden max-w-[400px] md:block'}
              radius={40}
              src={loadStaticFromPublic('sign-in-image-2.png')}
            />
            <div className={'hidden md:flex mt-4 justify-end max-w-[400px]'}>
              <Text
                c={'white'}
                className={'text-[12px] font-light opacity-80'}
                size={'xs'}
              >
                {'Powered by Xelto\r'}
              </Text>
            </div>
          </div>
        </section>
        <section
          className={clsx(
            'flex justify-start w-full z-20 px-8 py-8  md:w-[60vw] md:py-4 md:h-auto',
            isForgotOrResetPasswordStep ? 'px-4 md:px-12' : '',
            isLoginPageUiCenter ? 'md:justify-center' : '',
          )}
        >
          <div
            className={clsx(
              'flex flex-col w-full max-w-[650px]',
              isLoginPageUiCenter ? 'items-center justify-center' : 'items-start',
            )}
          >
            <div className={'hidden w-full md:block'}>
              {logoColor && (
                <div className={'flex justify-center'}>
                  <ClientLogo
                    height={145}
                    logoUrl={loadStaticFromPublic('xelto-apps-logo.jpg')}
                  />
                </div>
              )}
            </div>
            <Outlet />
          </div>
        </section>
      </div>
    </main>
  )
}
